document.addEventListener("DOMContentLoaded", function () {
    const sidebar = document.querySelector(".dashboard-sidebar");
    const toggler = document.querySelector(".dashboard-sidebar-toggler");
    const nav = document.querySelector(".dashboard-sidebar-nav");
    if(sidebar) {
        // Append a close button to the sidebar navigation
        const closeButton = document.createElement("span");
        closeButton.classList.add("dashboard-sidebar-close");
        closeButton.innerHTML=`Dashboard Menu <span class="icon icon-cross"></span>`
        nav.prepend(closeButton);

        // Toggle sidebar on toggler button click
        toggler.addEventListener("click", function () {
            sidebar.classList.toggle("expanded");
        });

        // Close sidebar on close button click
        closeButton.addEventListener("click", function () {
            sidebar.classList.remove("expanded");
        });
    }
});